import { ChainId } from '@/constant';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Menu, MenuItem } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import styled from 'styled-components';
import { useChainId, useSwitchChain } from 'wagmi';

// Network configuration
const NETWORKS = [
    {
        chainId: ChainId.lazaiMainnet,
        name: 'LazAI Mainnet',
        icon: require('@/assets/images/network/lazai.png'),
        color: '#3563F3',
    },
    {
        chainId: ChainId.lazaiTestnet,
        name: 'LazAI Testnet',
        icon: require('@/assets/images/network/lazai.png'),
        color: '#3563F3',
    },
    {
        chainId: ChainId.bscMainnet,
        name: 'BNB Chain',
        icon: require('@/assets/images/network/binance.png'),
        color: '#F0B90B',
    },
    {
        chainId: ChainId.bscTestnet,
        name: 'BNB Testnet',
        icon: require('@/assets/images/network/binance.png'),
        color: '#F0B90B',
    },
];

const SelectorButton = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background: #fff;
    border: 1px solid #ebeffe;
    border-radius: 12px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;

    &:hover {
        border-color: #3563f3;
        background: #f8faff;
    }
`;

const NetworkName = styled.span`
    color: #000;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        display: none;
    `}
`;

const StyledMenuItem = styled(MenuItem)`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 16px;
    min-width: 180px;

    &:hover {
        background: #f8faff;
    }

    &.Mui-selected {
        background: #ebeffe;
    }
`;

const MenuNetworkIcon = styled.img`
    width: 24px;
    height: 24px;
    border-radius: 50%;

    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
`;

const NetworkSelector: React.FC = observer(() => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const chainId = useChainId();
    const { switchChain } = useSwitchChain();

    const currentNetwork =
        NETWORKS.find((n) => n.chainId === chainId) || NETWORKS[0];

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleNetworkSwitch = async (targetChainId: number) => {
        try {
            if (switchChain) {
                switchChain({ chainId: targetChainId });
                // user.setChainId(targetChainId as ChainId);
            }
        } catch (error) {
            console.error('Failed to switch network:', error);
        }
        handleClose();
    };

    return (
        <>
            <SelectorButton onClick={handleClick}>
                <MenuNetworkIcon src={currentNetwork.icon} />
                <NetworkName>{currentNetwork.name}</NetworkName>
                <KeyboardArrowDownIcon
                    sx={{
                        fontSize: 20,
                        color: '#666',
                        transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.2s',
                    }}
                />
            </SelectorButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                sx={{
                    '& .MuiPaper-root': {
                        borderRadius: '12px',
                        marginTop: '8px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                    },
                }}
            >
                {NETWORKS.map((network) => (
                    <StyledMenuItem
                        key={network.chainId}
                        onClick={() => handleNetworkSwitch(network.chainId)}
                        selected={network.chainId === chainId}
                    >
                        <MenuNetworkIcon src={network.icon} />
                        <span>{network.name}</span>
                    </StyledMenuItem>
                ))}
            </Menu>
        </>
    );
});

export default NetworkSelector;
